// Collapse - clamps [data-collapse] sections taller than the given height and
// reveals their [data-collapse-trigger]. Behavioral port of v1 modules/Collapse.js.

export interface CollapseConfig {
  selector: string;
}

export default class Collapse {
  config: CollapseConfig;

  sections: HTMLElement[] = [];

  constructor(selector = '[data-collapse]', config: Partial<CollapseConfig> = {}) {
    this.config = { selector, ...config };

    this._init();
  }

  destroy(): void {
    this.sections.forEach(section => {
      Collapse.setNotCollapsible(section);
    });
    this.sections = [];
  }

  update(): void {
    this.destroy();
    this._init();
  }

  private _init(): void {
    this.sections.push(
      ...document.querySelectorAll<HTMLElement>(this.config.selector),
    );

    this.sections.forEach(section => {
      const height = Number(section.getAttribute('data-collapse'));

      if (section.offsetHeight > height) {
        Collapse.setCollapsible(section, height);
      }
    });
  }

  static setCollapsible(el: HTMLElement, height: number): void {
    el.classList.add('collapsed');
    el.style.maxHeight = `${height}px`;

    Collapse.showTrigger(el);
  }

  static setNotCollapsible(el: HTMLElement): void {
    if (el.classList.contains('collapsed')) {
      el.classList.remove('collapsed');
      el.style.maxHeight = 'none';

      Collapse.hideTrigger(el);
    }
  }

  static findTrigger(el: HTMLElement): Element | null {
    return el.parentElement?.querySelector('[data-collapse-trigger]') ?? null;
  }

  static showTrigger(el: HTMLElement): void {
    Collapse.findTrigger(el)?.classList.remove('hide');
  }

  static hideTrigger(el: HTMLElement): void {
    Collapse.findTrigger(el)?.classList.add('hide');
  }
}
